import React, { useState } from 'react';
import api from '../../api/api';

export default function MediaMaster({ resources, onRefresh }) {
  const [searchTerm, setSearchTerm] = useState('');
  const [page, setPage] = useState(1);
  const [editingId, setEditingId] = useState(null);
  const [editForm, setEditForm] = useState({});
  const [isAdding, setIsAdding] = useState(false);
  const [newForm, setNewForm] = useState({
    name: '',
    media_type: 'PRINT',
    is_active: true
  });

  const filteredResources = resources.filter(res => 
    res.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const itemsPerPage = 10;
  const totalPages = Math.ceil(filteredResources.length / itemsPerPage);
  const currentItems = filteredResources.slice((page - 1) * itemsPerPage, page * itemsPerPage);

  const handleEdit = (resource) => {
    setEditingId(resource.id);
    setEditForm({ ...resource });
  };

  const handleSave = async () => {
    try {
      await api.put(`/master/media-resources/${editingId}`, {
        name: editForm.name,
        media_type: editForm.media_type,
        is_active: editForm.is_active
      });
      setEditingId(null);
      onRefresh();
    } catch (error) {
      alert('Failed to update publication');
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure?')) return;
    try {
      await api.delete(`/master/media-resources/${id}`);
      onRefresh();
    } catch (error) {
      alert('Failed to delete publication');
    }
  };

  const handleAdd = async () => {
    try {
      await api.post('/master/media-resources', {
        name: newForm.name,
        media_type: newForm.media_type
      });
      setIsAdding(false);
      setNewForm({ name: '', media_type: 'PRINT', is_active: true });
      onRefresh();
    } catch (error) {
      alert('Failed to add publication');
    }
  };

  return (
    <>
      <div className="admin-card-header">
        <div style={{ display: 'flex', alignItems: 'center', gap: '1.5rem', flex: 1 }}>
          <h3>Publications</h3>
          <div className="search-box" style={{ position: 'relative', flex: 1, maxWidth: '400px' }}>
            <span style={{ position: 'absolute', left: '10px', top: '50%', transform: 'translateY(-50%)', color: '#94a3b8' }}>🔍</span>
            <input 
              type="text" 
              placeholder="Search publications..." 
              value={searchTerm}
              onChange={(e) => {
                setSearchTerm(e.target.value);
                setPage(1);
              }}
              style={{ 
                width: '100%', 
                padding: '0.6rem 1rem 0.6rem 2.5rem', 
                borderRadius: '0.5rem', 
                border: '1px solid #e2e8f0',
                fontSize: '0.9rem'
              }}
            />
          </div>
        </div>
        <button className="btn-primary small-btn" onClick={() => setIsAdding(true)}>+ Add Publication</button>
      </div>

      {isAdding && (
        <div style={{ padding: '1.5rem', background: '#f8fafc', borderBottom: '1px solid #e2e8f0' }}>
          <h4>Add New Publication</h4>
          <div style={{ display: 'flex', gap: '1rem', marginTop: '1rem', flexWrap: 'wrap' }}>
            <input 
              type="text" 
              placeholder="Publication Name" 
              value={newForm.name} 
              onChange={e => setNewForm({...newForm, name: e.target.value})}
              style={{ padding: '0.5rem', borderRadius: '0.4rem', border: '1px solid #cbd5e1' }}
            />
            <select 
              value={newForm.media_type} 
              onChange={e => setNewForm({...newForm, media_type: e.target.value})}
              style={{ padding: '0.5rem', borderRadius: '0.4rem', border: '1px solid #cbd5e1' }}
            >
              <option value="PRINT">PRINT</option>
              <option value="RADIO">RADIO</option>
              <option value="TV">TV</option>
              <option value="DIGITAL">DIGITAL</option>
            </select>
            <button className="btn-primary small-btn" onClick={handleAdd}>Save</button>
            <button className="btn-secondary small-btn" onClick={() => setIsAdding(false)}>Cancel</button>
          </div>
        </div>
      )}

      <div className="admin-table-wrapper">
        <table className="admin-table">
          <thead>
            <tr>
              <th>Publication Name</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {currentItems.map((resource) => (
              <tr key={resource.id}>
                <td>
                  {editingId === resource.id ? (
                    <input type="text" value={editForm.name} onChange={e => setEditForm({...editForm, name: e.target.value})} />
                  ) : (
                    <strong>{resource.name}</strong>
                  )}
                </td>
                <td>
                  {editingId === resource.id ? (
                    <input type="checkbox" checked={editForm.is_active} onChange={e => setEditForm({...editForm, is_active: e.target.checked})} />
                  ) : (
                    <span className={`status-badge ${resource.is_active ? 'active' : 'inactive'}`}>
                      {resource.is_active ? 'Active' : 'Inactive'}
                    </span>
                  )}
                </td>
                <td>
                  <div className="actions-cell">
                    {editingId === resource.id ? (
                      <button className="action-btn" onClick={handleSave} title="Save">💾</button>
                    ) : (
                      <button className="action-btn" onClick={() => handleEdit(resource)} title="Edit">✏️</button>
                    )}
                    <button className="action-btn" onClick={() => handleDelete(resource.id)} title="Delete">🗑️</button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {totalPages > 1 && (
        <div className="pagination-container" style={{ padding: '1rem' }}>
          <button className="pagination-btn" disabled={page === 1} onClick={() => setPage(page - 1)}>Prev</button>
          <span>Page {page} of {totalPages}</span>
          <button className="pagination-btn" disabled={page === totalPages} onClick={() => setPage(page + 1)}>Next</button>
        </div>
      )}
    </>
  );
}
